import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Routes, Route} from 'react-router-dom'

import './assets/webcssall.css'

import MainApp from './components/MainPage'
import reportWebVitals from './reportWebVitals';


const style = {
  backgroundImage: 'url(/paperbg.jpg)',
};

document.body.style.backgroundImage = style.backgroundImage;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
     <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  </div>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
